<template>
  <main class="main__career career">
    <div class="career__container container container--l">
      <h1 v-text="careerPage.title" />
      <article class="career__article" v-html="careerPage.text" />
      <div class="career__positions">
        <router-link :to="position.path" class="career__position" v-for="(position, p) in careerPage.positions"
          :key="p">
          <span class="career__label" v-text="position.title" />
          <span class="career__location" v-text="position.location" />
          <i class="career__arrow" />
        </router-link>
      </div>
    </div>
    <transition name="modal">
      <div class="career__modal modal" v-if="page.template === 'PositionTemplate'"
        data-career-modal>
        <div class="modal__dialog">
          <router-link :to="page.parent.path" tag="i" class="modal__close close"
          />
          <div class="modal__content">
            <router-view class="modal__position" />
          </div>
        </div>
        <router-link :to="page.parent.path" tag="i" class="modal__backdrop"
        />
      </div>
    </transition>
  </main>
</template>

<script>
import page from '@/mixins/page'

export default {
  mixins: [page],
  data() {
    return {
      careerPage: {}
    }
  },
  name: 'CareerTemplate',
  watch: {
    $route(to, from) {
      // react to route changes...
    }
  },
  methods: {},
  mounted() {
    this.careerPage =
      this.page.template === 'PositionTemplate' ? this.page.parent : this.page
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/CareerTemplate.vue